import { ScrollPosition } from 'react-lazy-load-image-component';
import { ChatMessage, ChatMessageAndGrouped, RoomStageInfo } from '../../common/types';
import { ChatTurn } from './ChatTurn';
import { createRef, useMemo } from 'react';
import { trackWindowScroll } from 'react-lazy-load-image-component';

function groupMessages(messages: ChatMessage[]) {
  const groupedMessages: ChatMessageAndGrouped[] = [];
  if (messages.length === 0 || messages.length === 1) {
    return messages;
  }
  for (let i = 1; i < messages.length; i++) {
    const prevMessage = messages[i - 1];
    const message = messages[i];
    // same author
    if (
      prevMessage.type === 'image' &&
      (message.type === 'text' || message.type === 'loading') &&
      message.author_type === prevMessage.author_type &&
      ((!message.user && !prevMessage.user) ||
        message.user?.userUuid === prevMessage.user?.userUuid)
    ) {
      groupedMessages.push({
        left: prevMessage,
        right: message,
        author_type: prevMessage.author_type,
        user: prevMessage.user,
        type: 'grouped',
        uuid: `${prevMessage.uuid}-${message.uuid}`,
        roomUuid: prevMessage.roomUuid,
        createdAt: prevMessage.createdAt,
      });
      i++;
    } else {
      groupedMessages.push(prevMessage);
      if (i === messages.length - 1) {
        groupedMessages.push(message);
      }
    }
  }
  return groupedMessages;
}

export type ChatBoxProps = {
  messages: ChatMessage[];
  authorColors: { [key: string]: string };
  scrollPosition: ScrollPosition;
  scrollToBottom?: () => void;
  stages: RoomStageInfo[];
};

function ChatBox(props: ChatBoxProps) {
  const chatBottomRef = createRef<HTMLDivElement>();
  const { messages, authorColors } = props;
  const groupedMessages = useMemo(() => groupMessages(messages), [messages]);
  const lastImageIdx = useMemo(
    () =>
      groupedMessages.findLastIndex(
        (m) =>
          m.type === 'image' ||
          (m.type === 'grouped' && (m.left.type === 'image' || m.right.type === 'image')),
      ),
    [groupedMessages],
  );

  return (
    <div className="flex flex-col px-4 space-y-2 mx-auto lg:max-w-7xl">
      {groupedMessages.map((item, index) => (
        <ChatTurn
          key={item.uuid ? item.uuid : `message-${index}`}
          index={index}
          length={messages.length}
          message={item}
          colorLookup={authorColors}
          scrollPosition={props.scrollPosition}
          stages={props.stages}
          onLoad={
            index === lastImageIdx && props.scrollToBottom !== undefined
              ? () => {
                  if (props.scrollToBottom) {
                    console.log('scrolling to bottom');
                    props.scrollToBottom();
                  }
                }
              : undefined
          }
        />
      ))}
      {/* {error && !loading && <ErrorTurn error={error} />} */}
      <div key="bottom" ref={chatBottomRef} />
    </div>
  );
}

export default trackWindowScroll(ChatBox);
